import { useNavigate } from "react-router-dom";

export const useRedirect = () => {
  const navigate = useNavigate();

  const redirectToEdit = (id) => {
    navigate(`/edit_user/${id}`);
  };

  return { redirectToEdit };
};
